import React from "react";
import PropTypes from "prop-types";
import StackedBarChart from "../../StackedBarChart/StackedBarChart";
import PieChart from "../../PieChart/PieChart";

function TotalPointsDistributionChart({ stats, otherPlayerStats }) {
  const { winner, forced, error } = stats;
  let totalWinner =
    winner.forehand + winner.backhand + winner.volley + winner.smash;
  let totalForced =
    forced.forehand + forced.backhand + forced.volley + forced.smash;
  let totalError = error.forehand + error.backhand + error.volley + error.smash;

  let otherPlayersWinner = otherPlayerStats.reduce(
    (sum, player) =>
      sum + player.stats.points.winner.forehand + player.stats.points.winner.backhand + player.stats.points.winner.volley + player.stats.points.winner.smash,
    0
  );
  let otherPlayersForced = otherPlayerStats.reduce(
    (sum, player) =>
      sum + player.stats.points.forced.forehand + player.stats.points.forced.backhand + player.stats.points.forced.volley + player.stats.points.forced.smash,
    0
  );
  let otherPlayersError = otherPlayerStats.reduce(
    (sum, player) =>
      sum + player.stats.points.error.forehand + player.stats.points.error.backhand + player.stats.points.error.volley + player.stats.points.error.smash,
    0
  );
  return (
    <PieChart
      title="Totale colpi"
      labels={["Vincente", "Forzato avversario", "Gratuito avversario", "Forzato", "Gratuito", "Vincente avversario"]}
      datasets={[
        {
          data: [totalWinner, otherPlayersForced, otherPlayersError, totalForced, totalError, otherPlayersWinner],
          backgroundColor: ["#5cb85c", "#81c784", "#a5d6a7", "#f0ad4e", "#d9534f", "#e57373"],
        },
      ]}
    />
  );
}

TotalPointsDistributionChart.propTypes = {};

export default TotalPointsDistributionChart;
